import { createContext } from "react";
import { ThemeProvider as ThemeProviderComponent } from "@mui/material/styles";
import { theme } from "../themes/main";

export const ThemeContext = createContext({});

export default function ThemeProvider({ children }: any) {
    return <ThemeProviderComponent theme={theme}>{children}</ThemeProviderComponent>;
}
